import type React from 'react';
import { useTranslation } from 'react-i18next';
import { AccountFormDrawer } from '@/pages/accounting/books/chartOfAccounts/components/accountForm/AccountFormDrawer';
import { useChartOfAccounts } from '@/api/queries';
import { resolveLocale } from '@/pages/accounting/statements/statementMeta';
import { PATH } from '@/router/PATH';
import type { ActionSurfaceProps } from '../../controlCenterSurfaces';

/**
 * "Add account" from the launcher — the Chart of Accounts' **own** drawer, not
 * a second account form.
 *
 * `instanceId` is a constant here: `ActionSurfaceHost` already remounts this
 * whole component fresh on every open, so there is no second opening for a
 * bumped id to distinguish from the first.
 */
export const AddAccountSurface: React.FC<ActionSurfaceProps> = ({
    onClose,
    onDone,
}) => {
    const { i18n } = useTranslation('pages');
    const locale = resolveLocale(i18n.language);
    const chart = useChartOfAccounts({ locale });

    return (
        <AccountFormDrawer
            account={null}
            accounts={chart.data ?? []}
            instanceId={0}
            isOpen
            locale={locale}
            onClose={onClose}
            onSaved={() =>
                onDone({
                    messageKey: 'controlCenter.outcome.accountAdded',
                    to: PATH.ACCOUNTING.BOOKS.ACCOUNTS,
                    linkKey: 'controlCenter.outcome.openAccounts',
                })
            }
        />
    );
};
